module.exports = __webpack_public_path__ + "img/KSC03536.e6337581.jpg";